import { render } from "./CADProjects.vue?vue&type=template&id=f704a276&scoped=true"
import script from "./CADProjects.vue?vue&type=script&lang=js"
export * from "./CADProjects.vue?vue&type=script&lang=js"

import "./CADProjects.vue?vue&type=style&index=0&id=f704a276&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f704a276"]])

export default __exports__